import { UIOverride } from "./ui-overrde/UIOverride";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { PhotoView } from "@src/lms/jelly/extensions/layouts/photo-view/PhotoView";
import { WrappedContent } from "@src/lms/jelly/extensions/layouts/wrapped-content/WrappedContent";
import { Carousel } from "@src/lms/jelly/extensions/layouts/carousel/Carousel";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { BlockContainer } from "@src/lms/jelly/extensions/components";
import { SimpleScrollableLayoutView } from "@src/lms/jelly/extensions/layouts/scrolable-simple/SimpleScrollableLayoutView";

export * from "./_lesson";

export const UpstreamUIOverride = UIOverride;

export const SpatialStandardCase = StandardCase;
export const SpatialPhotoView = PhotoView;
export const SpatialWrappedContent = WrappedContent;
export const SpatialCarousel = Carousel;
export const SpatialSimpleView = SimpleLayoutView;
export const SpatialSimpleScrollableView = SimpleScrollableLayoutView;
export const SpatialBlockContainer = BlockContainer;
